import { Divider, Text } from '@mantine/core';

export const SectionDivider = ({ label }: { label: string }) => {
  return (
    <Divider
      mb="sm"
      label={<Text size={'20px'}>{label}</Text>}
      labelPosition="left"
      variant="dotted"
    />
  );
};
